import { create } from 'zustand';

/**
 * Mémorise qu'une requête a reçu `subscription_required` (HTTP 402) pour une organisation : la garde de routes
 * redirige alors vers l'écran « Choisir une offre ». Effacé dès qu'une offre est choisie.
 */
interface GateState {
  requiredOrg: string | null;
  flag: (org: string) => void;
  clear: () => void;
}

export const useSubscriptionGate = create<GateState>((set) => ({
  requiredOrg: null,
  flag: (org) => set({ requiredOrg: org }),
  clear: () => set({ requiredOrg: null }),
}));

/** Vrai si le plan effectif impose de choisir une offre avant d'utiliser la console (plan gratuit). */
export function needsOffer(planId: string): boolean {
  return planId === 'free';
}
